// @flow
import axios from 'lib/defaultClient';

export const getDepositBalance = (): Promise<*> => axios.get('/deposit');

export const getDepositHistory = (params: any): Promise<*> =>
  axios.get('/deposit/history', { params });



// WEBPACK FOOTER //
// ./src/lib/api/deposit.js